import {
    IonCard, IonCardHeader, IonCardSubtitle, IonCardTitle,
    IonContent,
    IonRefresher,
    IonRefresherContent,
    IonSpinner, useIonToast
} from "@ionic/react";
import React, {useCallback, useEffect, useState} from "react";
import {errorToastOptions} from "../../components/ErrorToast";
import {getUser} from "../../repositories/adminUserRepository";
import {AdminManageUserNames} from "../../components/admin/AdminManageUserNames";

export const AdminUserUserNames = ({userId}) => {
    const [user, setUser] = useState(null);
    const [userNames, setUserNames] = useState([]);
    const [presentToast] = useIonToast();

    const loadUser = useCallback(async () => {
        try {
            const userResponse = await getUser(userId);
            setUser(userResponse.user);
            setUserNames(userResponse.userNames);
        } catch (e) {
            const message = typeof e.response?.data === 'string' && e.response.data ? e.response.data : "Failed to load user";
            await presentToast(errorToastOptions(message));
        }
    }, [userId, presentToast]);

    useEffect(() => {
        setUser(null);
        loadUser();
    }, [loadUser]);

    const reload = async (event) => {
        try {
            await loadUser();
        } finally {
            event.detail.complete();
        }
    }

    if (!user) {
        return <IonContent fullscreen>
            <div className="custom-spinner">
                <IonSpinner></IonSpinner>
            </div>
        </IonContent>
    }

    return <IonContent fullscreen>
        <IonRefresher slot="fixed" onIonRefresh={reload}>
            <IonRefresherContent></IonRefresherContent>
        </IonRefresher>
        <IonCard>
            <IonCardHeader>
                <IonCardTitle>{ user.name }</IonCardTitle>
                <IonCardSubtitle>User names of this user in each service type</IonCardSubtitle>
            </IonCardHeader>
        </IonCard>
        <AdminManageUserNames user={user} userNames={userNames} setUserNames={setUserNames} reloadUserNames={loadUser} />
    </IonContent>
}
